import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {identitiesApi} from '../../app/services/identitiesApi';
import {logout} from '../auth/authSlice';
import {BiotandemInfo, Patient} from './types';

export interface IntegrationDemoState {
  patients: Patient[];
  biotandemInfo: BiotandemInfo[];
}

export const initialState: IntegrationDemoState = {
  patients: generatePatients(),
  biotandemInfo: [
    {
      patientId: 1,
      biotwinId: 1,
      hasUpdates: true,
    },
    {
      patientId: 2,
      biotwinId: 2328,
      hasUpdates: false,
    },
  ],
};

export const integrationDemoSlice = createSlice({
  name: 'integrationDemo',
  initialState,
  reducers: {
    addBiotandemInfo: (state, action: PayloadAction<BiotandemInfo>) => {
      state.biotandemInfo.push(action.payload);
    },
    updateBiotandemInfo: (state, action: PayloadAction<BiotandemInfo>) => {
      state.biotandemInfo = state.biotandemInfo.map((info) =>
        info.patientId === action.payload.patientId ? action.payload : info,
      );
    },
    updatePatient: (state, action: PayloadAction<Patient>) => {
      state.patients = state.patients.map((patient) => (patient.id === action.payload.id ? action.payload : patient));
    },
    updatePatients: (state, action: PayloadAction<Patient[]>) => {
      state.patients = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logout, () => {
      return initialState;
    });
    builder.addMatcher(identitiesApi.endpoints.registerVerifyOTP.matchFulfilled, () => {
      return initialState;
    });
  },
});

export const {addBiotandemInfo, updateBiotandemInfo, updatePatient, updatePatients} = integrationDemoSlice.actions;

export const selectPatients = (state: {integrationDemo: IntegrationDemoState}) => state.integrationDemo.patients;

export const selectBiotandemInfo = (state: {integrationDemo: IntegrationDemoState}) =>
  state.integrationDemo.biotandemInfo;

export default integrationDemoSlice.reducer;

function generatePatients(): Patient[] {
  return [
    {
      id: 1,
      name: 'John Doe',
      age: 30,
      email: 'john.doe@example.com',
      address: '123 Main St, Anytown, USA',
      phone: '555-1234',
      height: 175,
      weight: 70,
      gender: 'male',
    },
    {
      id: 2,
      name: 'Jane Doe',
      age: 30,
      email: 'jane.doe@example.com',
      address: '123 Main St, Anytown, USA',
      phone: '555-1234',
      height: 165,
      weight: 60,
      gender: 'female',
    },
    {
      id: 3,
      name: 'Alice Smith',
      age: 28,
      email: 'alice.smith@example.com',
      address: '456 Oak St, Sometown, USA',
      phone: '555-5678',
      height: 160,
      weight: 55,
      gender: 'female',
    },
    {
      id: 4,
      name: 'Bob Johnson',
      age: 35,
      email: 'bob.johnson@example.com',
      address: '789 Pine St, Othertown, USA',
      phone: '555-8765',
      height: 180,
      weight: 80,
      gender: 'male',
    },
  ];
}
